<template>
    <table class="table mb-0">
        <thead class="bg-light">
            <tr>
                <th scope="col" class="border text-left">Agreement</th>
                <th scope="col" class="border text-left">Agreed on</th>
                <th scope="col" class="border text-left">Download</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="border text-left"><a :href="`${IVANHOE_URL}/terms`">Terms of service</a></td>
                <td class="border text-left">{{ userInfo.created_at }}</td>
                <td class="border text-left"><i class="material-icons agreement-text">file_download</i><a class="ml-2" :href="`${IVANHOE_URL}/signed-agreements/terms/download?token=${token}`">Terms of service</a></td>
            </tr>
            <tr>
                <td class="border text-left"><a :href="`${IVANHOE_URL}/privacy`">Privacy policy</a></td>
                <td class="border text-left">{{ userInfo.created_at }}</td>
                <td class="border text-left"><i class="material-icons">file_download</i><a class="ml-2" :href="`${IVANHOE_URL}/signed-agreements/privacy/download?token=${token}`">Privacy policy</a></td>
            </tr>
            <tr>
                <td class="border text-left"><a :href="`${IVANHOE_URL}/disclaimer`">Disclaimer</a></td>
                <td class="border text-left">{{ userInfo.created_at }}</td>
                <td class="border text-left"><i class="material-icons">file_download</i><a class="ml-2" :href="`${IVANHOE_URL}/signed-agreements/disclaimer/download?token=${token}`">Disclaimer</a></td>
            </tr>
            <tr>
                <td class="border text-left"><a :href="`${IVANHOE_URL}/signed-agreements/gdbr/download?token=${token}`">GDPR</a></td>
                <td class="border text-left">{{ userInfo.created_at }}</td>
                <td class="border text-left"><i class="material-icons">file_download</i><a class="ml-2" :href="`${IVANHOE_URL}/signed-agreements/gdbr/download?token=${token}`">GDPR</a></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import { AuthService } from '@/main'
    import env from '@/mixins/env'

    export default {
        mixins: [env],

        data() {
            return {
                token: AuthService.getToken(),
            }
        },

        computed: {
            userInfo() {
                return this.$store.getters.userInfo
            }
        }
    }
</script>
